import { pxToRem } from "../../private/helpers";
var paddingHelper = _ref => {
  var {
    theme,
    $sizeVariant,
    $compact,
    $variant,
    disabled
  } = _ref;
  var {
    spacing,
    border
  } = theme;
  var borderWidth = border.width.thin;
  var hasBorder = $variant === "outline" || disabled && $variant !== "naked";
  var padding = {
    large: hasBorder ? "calc(" + spacing.small + " - " + borderWidth + ") calc(" + spacing.large + " - " + borderWidth + ")" : spacing.small + " " + spacing.large,
    medium: hasBorder ? "calc(" + spacing.extraSmall + " - " + borderWidth + ") calc(" + spacing.large + " - " + borderWidth + ")" : spacing.extraSmall + " " + spacing.large,
    small: hasBorder ? "calc(" + pxToRem(6) + " - " + borderWidth + ") calc(" + spacing.medium + " - " + borderWidth + ")" : pxToRem(6) + " " + spacing.medium
  };
  var compactPadding = {
    large: hasBorder ? "calc(" + spacing.small + " - " + borderWidth + ")" : "" + spacing.small,
    medium: hasBorder ? "calc(" + spacing.extraSmall + " - " + borderWidth + ")" : "" + spacing.extraSmall,
    small: hasBorder ? "calc(" + pxToRem(6) + " - " + borderWidth + ")" : "" + spacing.extraSmall
  };
  return $compact ? compactPadding[$sizeVariant] : padding[$sizeVariant];
};
var colorHelper = _ref2 => {
  var {
    $variant,
    disabled,
    theme
  } = _ref2;
  var standardColors = {
    primary: theme.palette.textInvertedStatic,
    outline: theme.palette.textPrimary,
    secondary: theme.palette.textInverted,
    naked: theme.palette.textPrimary
  };
  return disabled ? theme.palette.textDisabled : standardColors[$variant];
};
var backgroundColorHelper = state => _ref3 => {
  var {
    $variant,
    disabled,
    theme
  } = _ref3;
  var standardColors = {
    primary: theme.palette.backgroundBrandStatic,
    outline: "transparent",
    secondary: theme.palette.backgroundPrimaryInverted,
    naked: "transparent"
  };
  var disabledColors = {
    primary: theme.palette.backgroundDisabled,
    outline: theme.palette.backgroundDisabled,
    secondary: theme.palette.backgroundDisabled,
    naked: "transparent"
  };
  var hoverColors = {
    primary: theme.palette.backgroundHoveredBrandStatic,
    outline: theme.palette.backgroundHoveredPrimary,
    secondary: theme.palette.backgroundHoveredPrimaryInverted,
    naked: theme.palette.backgroundHoveredPrimary
  };
  var pressedColors = {
    primary: theme.palette.backgroundPressedBrandStatic,
    outline: theme.palette.backgroundPressedPrimary,
    secondary: theme.palette.backgroundPressedPrimaryInverted,
    naked: theme.palette.backgroundPressedPrimary
  };
  if (disabled) return disabledColors[$variant];else if (state === "hover") return hoverColors[$variant];else if (state === "pressed") return pressedColors[$variant];else return standardColors[$variant];
};
var borderHelper = state => _ref4 => {
  var {
    theme,
    disabled,
    $variant
  } = _ref4;
  var {
    border,
    palette
  } = theme;
  var outlineBorders = {
    standard: border.width.thin + " solid " + palette.borderPrimary,
    disabled: border.width.thin + " solid " + palette.borderDisabled,
    focus: border.width.thick + " solid " + palette.borderFocused,
    hover: border.width.thin + " solid " + palette.borderHovered,
    pressed: border.width.thin + " solid " + palette.borderPressed
  };
  if (state === "focus") return outlineBorders.focus;
  if ($variant === "naked") return undefined;
  if (disabled) return outlineBorders.disabled;
  if ($variant !== "outline") return undefined;else if (state) return outlineBorders[state];else return outlineBorders.standard;
};
var focusPositionHelper = _ref5 => {
  var {
    $variant
  } = _ref5;
  if ($variant === "naked") return "0";
  if ($variant === "outline") return pxToRem(-6);else return pxToRem(-5);
};
var minSizeHelper = _ref6 => {
  var {
    $sizeVariant,
    theme
  } = _ref6;
  var {
    spacing
  } = theme;
  var minSize = {
    large: spacing.threeExtraLarge,
    medium: spacing.twoExtraLarge,
    small: spacing.extraLarge
  };
  return minSize[$sizeVariant];
};
export { paddingHelper, backgroundColorHelper, colorHelper, borderHelper, focusPositionHelper, minSizeHelper };